import { useChatConversations } from "hooks/chat/useChatConversations.hook";
import * as conversationsSync from "services/sync/resources/chat/conversations.sync";

export function useChatSupervisorConversations({ enabled = true, lineId, userId } = {}) {
  return useChatConversations({
    enabled,
    lineId,
    userId,
    syncFn: conversationsSync.supervisor,
  });
}